"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.contextDetailData = graphql_tag_1.default `
  fragment contextDetailData on Context {
    id
    name
    resourceUrl
    contextVariables
  }
`;
//# sourceMappingURL=contexts.js.map